import config from '../config';
import { ArrayUtils, StringUtils } from  '../utils';
import { ActionTypes as actions, UserActions, ConsultationsActions, ToastActions } from '../actions';
import { History as history, Routes as routes } from '../navigation';
import axios from 'axios';

const displayError = (message, data) => {
  return dispatch => {
    var errorMessage = '';
    if (data) {
      errorMessage = data.error && data.error.message ? data.error.message : '';
    }
    if (message) {
      errorMessage = message;
    }
    dispatch(ToastActions.displayError(errorMessage));
  }
}

const displayInfo = (message) => {
  return dispatch => {
    dispatch(ToastActions.displayInfo(message));
  }
}

const getSelectedPractice = (prac_id, navigate) => {
  return (dispatch, getState) => {

    let state         = getState();
    let token         = state.user && state.user.auth && state.user.auth.token ? state.user.auth.token : '';
    let practice_id   = state.context && state.context.selectedPractice ? state.context.selectedPractice : '';

    if (prac_id) {
      practice_id = prac_id;
    }

    let requestURL    = `${config.BASE_URL}/api/practice/${practice_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      let data     = response.data || {};
      let practice = data.data;
      if (practice) {
        dispatch(getSelectedPracticeSubscription(token, practice_id));
        dispatch({ type: actions.PRACTICE_UPDATE_PRACTICE, payload: practice });
      }
      if (practice && navigate) {
        let is_instant = practice.subscription && practice.subscription.subscription_type && (practice.subscription.subscription_type === 'INSTANT' || practice.subscription.subscription_type === 'INSTANT_PAID');
        if (is_instant) {
          history.push(routes.INSTANT_HOME);
        } else {
          history.push(routes.HOME);
        }
      }
    }).catch((error) => {
      console.log(error)
    })

  }
}

const getSelectedPracticeSubscription = (token, practice_id) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/subscription/get/${practice_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      let data     = response.data || {};
      let practice = data.data;

      if (data.success === true && data.subscription) {
        let subscription_data = {
          subscription: data.subscription,
          stripe_subscription: data.stripe_subscription,
          customer: data.customer,
          enterprise: data.enterprise,
        }
        dispatch({ type: actions.PRACTICE_UPDATE_PRACTICE_SUBSCRIPTION, payload: subscription_data });
      }

    }).catch((error) => {
      console.log(error)
    })

  }
}

const createNewPractice = (token, user_id, data, callBack) => {
  return (dispatch, getState) => {
    const requestURL = `${config.BASE_URL}/api/practice`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    dispatch({ type: actions.LOADING_CREATE_NEW_PRACTICE, payload: true });

    axios.post(requestURL, JSON.stringify(data), requestConfig).then((response) => {
      const data = response.data || {};
      const practice = data.practice || {};
      const practice_id = practice._id || '';

      if (data.success === true) {
        dispatch(UserActions.getUserRoles(token, user_id, true));
        dispatch(ToastActions.displayInfo('New Practice Created!'))
        if (practice_id) {
          dispatch(getPracticeNotificationPreferences(token, practice_id));
        }
        if (callBack) {
          callBack();
        }
      } else { dispatch(displayError('', data)) }
      dispatch({ type: actions.LOADING_CREATE_NEW_PRACTICE, payload: false });
    }).catch((error) => {
      dispatch({ type: actions.LOADING_CREATE_NEW_PRACTICE, payload: false });
      console.log(error)
    });

  }
}

const populateSelectedPracticeInfo = () => {
  return (dispatch, getState) => {

    const allPractices = getState().user.practices || {};
    const selectedPractice = getState().context.selectedPractice || '';

    if (allPractices && selectedPractice && allPractices[selectedPractice]) {
      const selectedPracticeInfo = allPractices[selectedPractice];
      dispatch({
        type: actions.PRACTICE_INFO_UPDATE,
        payload: selectedPracticeInfo
      });
    }
  }
}

const addPracticeLocation = (token, location, successCallback) => {
  return (dispatch, getState) => {

    const requestURL = `${config.BASE_URL}/api/practice/location`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    dispatch({ type: actions.LOADING_ADD_EDIT_LOCATION, payload: true });

    axios.post(requestURL, JSON.stringify(location), requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getPracticeLocations(token, location.practice_id));
        dispatch(ToastActions.displayInfo('Practice Location Added!'))
        if (successCallback) {
          successCallback();
        }
      }
      dispatch({ type: actions.LOADING_ADD_EDIT_LOCATION, payload: false });
    }).catch((error) => {
      dispatch({ type: actions.LOADING_ADD_EDIT_LOCATION, payload: false });
      console.log(error)
    });

  }
}

const editPracticeLocation = (token, location, successCallback, skipToast) => {
  return (dispatch, getState) => {

    const requestURL = `${config.BASE_URL}/api/practice/location/${location._id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    dispatch({ type: actions.LOADING_ADD_EDIT_LOCATION, payload: true });

    axios.put(requestURL, JSON.stringify(location), requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getPracticeLocations(token, location.practice_id));
        if (!skipToast) {
          dispatch(ToastActions.displayInfo('Saved Practice Location Info!'))
        }
        if (successCallback) {
          successCallback();
        }
      } else { console.log(data) }
      dispatch({ type: actions.LOADING_ADD_EDIT_LOCATION, payload: false });
    }).catch((error) => {
      dispatch({ type: actions.LOADING_ADD_EDIT_LOCATION, payload: false });
      console.log(error)
    });

  }
}

const getProration = (token, practice_id, price, proration_date, timeframe, callBack) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/subscription/check_proration/${practice_id}/${price}/${timeframe}/${proration_date}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};

      console.log('RETRIEVING PRORATION', data)
      callBack(data);
    }).catch((error) => {
      console.log(error)
    })

  }
}

const getPracticeLocations = (token, practice_id, callback) => {
  return (dispatch, getState) => {

    const requestURL = `${config.BASE_URL}/api/practice/location/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const locations = data.locations || [];
      if (locations && locations.length > 0) {
        if (callback) {
          callback(locations)
        } else {
          locations.forEach((location) => {
            dispatch({ type: actions.PRACTICE_LOCATION_ADD, payload: location });
            dispatch(getPracticeLocationDetails(token, location));
          })
          dispatch(getFrontDeskAccounts(token, practice_id));
        }
      }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeLocationDetails = (token, location) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/location_details/${location._id}/${location.code}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const locationMembers = data.location_roles || [];
      if (data.success === true) {
        const membersInfo = { location_id: location._id, members: locationMembers }
        dispatch({ type: actions.PRACTICE_LOCATION_MEMBERS_ADD, payload: membersInfo });
      }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeClientUserInfo = (token, user_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/user/${user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const user = data.data;
      if (user) {
        dispatch({
          type: actions.USER_ADD_USER,
          payload: user
        });
      }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeUserInfo = (user_id, token) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/provider/${user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const user = data.data;
      if (user) {
        dispatch({
          type: actions.USER_ADD_USER,
          payload: user
        });
      }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeUserRoles = (user_id, practice_id, token) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/user_roles/${user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const roles = data.roles || [];
      if (roles.length > 0) {
        var thisPracticesRoles = null;
        roles.forEach((role) => {
          if (role.practice_id === practice_id) {
            thisPracticesRoles = role;
          }
        });
        if (thisPracticesRoles) {
          dispatch({
            type: actions.PRACTICE_USER_ROLE_ADD,
            payload: thisPracticesRoles
          });
        }
      }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticePatientInfo = (patient_id, token) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/patient/${patient_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const patient = data.data || {};
      if (data.success === true) {
        dispatch({
          type: actions.PRACTICE_ADD_PATIENT,
          payload: patient
        })
      }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeJoinRequests = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/join_request/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const requests = data.data || [];
      if (requests && requests.length > 0) {
        requests.forEach((request) => {
          const requestUserID = request.user_id;
          dispatch(getPracticeUserInfo(requestUserID, token));
          dispatch(getPracticeUserRoles(requestUserID, practice_id, token))
        })
      }
      dispatch({
        type: actions.PRACTICE_JOIN_REQUESTS_UPDATE,
        payload: requests
      });
    }).catch((error) => { console.log(error) });

  }
}

const deletePracticeJoinRequest = (token, request_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/join_request/${request_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.delete(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const deletedRequest = data.data;
      const practice_id = deletedRequest.practice_id
      dispatch(getPracticeJoinRequests(token, practice_id))
    }).catch((error) => { console.log(error) });

  }
}

const declinePracticeJoinRequest = (token, practice_id, user_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/join_request/remove/${practice_id}/${user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.delete(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getPracticeJoinRequests(token, practice_id))
      }
    }).catch((error) => { console.log(error) });

  }
}

const acceptPracticeJoinRequest = (token, request_id, roles, locations, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/join_request/accept/${request_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    const requestBody = {
      roles: roles,
      locations: locations,
    }

    axios.post(requestURL, JSON.stringify(requestBody), requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getPracticeJoinRequests(token, practice_id))
        dispatch(ToastActions.displayInfo('Practice Join Request Accepted'));
      }
    }).catch((error) => { console.log(error) });

  }
}

const selectPracticeLocationToEdit = (location, createNew) => {
  return dispatch => {
    var locationEditInfo = {
      location: location || {},
      type: createNew === true ? 'new' : 'edit',
    }

    dispatch({
      type: actions.PRACTICE_EDIT_LOCATION_UPDATE,
      payload: locationEditInfo
    });
    history.push(routes.PRACTICE_LOCATION_EDIT);
  }
}

const getPracticeActiveConsultations = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/practice/active/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const consultations  = data.data || [];

      if (data.success === true) {

        let active_consultation_ids     = [];
        let unassigned_consultation_ids = [];
        let consultations_info          = [];

        consultations.sort((a, b) => { return new Date(b.created_at) - new Date(a.created_at) });

        consultations.forEach((consultation) => {
          dispatch(getPracticeUserInfo(consultation.primary_assignee, token));
          dispatch(getPracticeClientUserInfo(token, consultation.primary_client));
          dispatch(getPracticePatientInfo(consultation.patient_id, token));
          consultations_info.push(consultation);
          if (consultation.primary_assignee === 'unassigned') {
            unassigned_consultation_ids.push(consultation._id);
          } else {
            active_consultation_ids.push(consultation._id);
          }
        })

        dispatch({
          type: actions.CONSULTATION_UPDATE_INFO,
          payload: consultations_info
        })

        dispatch({
          type: actions.PRACTICE_ACTIVE_CONSULTATIONS_UPDATE,
          payload: active_consultation_ids
        });
        dispatch({
          type: actions.PRACTICE_UNASSIGNED_CONSULTATIONS_UPDATE,
          payload: unassigned_consultation_ids
        })

      }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeResolvedConsultations = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/practice/resolved/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const resolvedConsultationsArray = data.data || [];
      if (data.success === true) {

        var resolvedConsultationIDs = [];

        resolvedConsultationsArray.sort((a, b) => { return new Date(b.created_at) - new Date(a.created_at) });

        resolvedConsultationsArray.forEach((consultation) => {
          dispatch(getPracticeUserInfo(consultation.primary_assignee, token));
          dispatch(getPracticeClientUserInfo(token, consultation.primary_client));
          dispatch(getPracticePatientInfo(consultation.patient_id, token));
          resolvedConsultationIDs.push(consultation._id);
        })

        dispatch({
          type: actions.CONSULTATION_UPDATE_INFO,
          payload: resolvedConsultationsArray
        })

        dispatch({
          type: actions.PRACTICE_RESOLVED_CONSULTATIONS_UPDATE,
          payload: resolvedConsultationIDs
        })
      }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeProcessingConsultations = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/consultation/practice/processing/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const processingConsultationsArray = data.data || [];

      if (data.success === true) {

        var processingConsultationIDs = [];

        processingConsultationsArray.sort((a, b) => { return new Date(b.created_at) - new Date(a.created_at) });

        processingConsultationsArray.forEach((consultation) => {
          dispatch(getPracticeUserInfo(consultation.primary_assignee, token));
          dispatch(getPracticeClientUserInfo(token, consultation.primary_client));
          dispatch(getPracticePatientInfo(consultation.patient_id, token));
          processingConsultationIDs.push(consultation._id);
        })

        dispatch({
          type: actions.CONSULTATION_UPDATE_INFO,
          payload: processingConsultationsArray
        })

        dispatch({
          type: actions.PRACTICE_PROCESSING_CONSULTATIONS_UPDATE,
          payload: processingConsultationIDs
        })
      }
    }).catch((error) => { console.log(error) });

  }
}

const editPracticeInfo = (token, practice, successCallback) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/${practice._id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.put(requestURL, JSON.stringify(practice), requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(UserActions.getPractice(practice._id, token, false));
        dispatch(ToastActions.displayInfo('Saved Practice Info!'))
        if (successCallback) {
          successCallback();
        }
      }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeStaff = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/provider/list/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const staffArray = data.providers || [];
      if (data.success === true) {
        dispatch({ type: actions.PRACTICE_PROVIDER_LOCATION_DICT_UPDATE, payload: null });
        staffArray.forEach((user_info) => {
          let user_id = user_info.user_id;
          dispatch(UserActions.getProviderPracticticeLocations(token, user_id, practice_id));
        });

        dispatch({
          type: actions.PRACTICE_STAFF_UPDATE,
          payload: staffArray
        })
      }
    }).catch((error) => { console.log(error) });

  }
}

const updatePracticeUserRole = (token, user_roles, successCallback) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/user_roles/${user_roles._id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.put(requestURL, JSON.stringify(user_roles), requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getPracticeStaff(token, user_roles.practice_id));
        dispatch(updateSelectedStaffMemberRoles(user_roles))
        dispatch(ToastActions.displayInfo('Saved Changes!'));
        if (successCallback) {
          successCallback();
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const addPracticeBank = (token, bankInfo, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/payment/practice/stripe_bank_accounts/add`;
    dispatch({ type: actions.LOADING_SAVE_BANK, payload: true });

    axios.post(requestURL, JSON.stringify(bankInfo), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(getPracticeBank(token, bankInfo.practice_id));
        dispatch(ToastActions.displayInfo('Bank Info Saved!'));
        if (callBack) {
          callBack();
        }
      } else { console.log(data) }
      dispatch({ type: actions.LOADING_SAVE_BANK, payload: false });
    }).catch((error) => {
      dispatch({ type: actions.LOADING_SAVE_BANK, payload: false });
      console.log(error)
    });

  }
}

const getPracticeBank = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/payment/practice/get/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const bankData = data.bank_accounts;
      const bankAccount = bankData && bankData.data && bankData.data[0] ? bankData.data[0] : null;

      if (data.success && bankAccount) {
        dispatch({ type: actions.PRACTICE_UPDATE_BANK, payload: bankAccount })
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeClients = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/clients/all/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const clients = data.clients || [];
      if (data.success) {
        dispatch({ type: actions.PRACTICE_CLIENTS_UPDATE, payload: clients });
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const createPracticeStripeAccount = (token, account_info, callback) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/payment/practice/stripe_acount/add`;
    dispatch({ type: actions.LOADING_SET_BANK_COMPANY, payload: true });

    axios.post(requestURL, JSON.stringify(account_info), requestConfig).then((response) => {
      const data = response.data;

      if (data.success) {
        dispatch(getPracticeStripeAccount(token, account_info.practice_id));
        dispatch(ToastActions.displayInfo('Payment Account Created!'));
        if (callback) {
          callback();
        }
      } else { console.log(data) }
      dispatch({ type: actions.LOADING_SET_BANK_COMPANY, payload: false });
    }).catch((error) => {
      dispatch({ type: actions.LOADING_SET_BANK_COMPANY, payload: false });
      console.log(error)
    });

  }
}

const getPracticeStripeAccount = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/payment/practice/stripe_acount/get/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data           = response.data || {};
      const stripe_account = data.stripe_account;

      if (data.success && stripe_account) {
        let stripe_account_id = stripe_account.id;
        dispatch(getPracticeStripeVerificationLink(token, stripe_account_id));
        dispatch(getPracticeStripeAccountUpdateLink(token, stripe_account_id));
        dispatch({ type: actions.PRACTICE_UPDATE_STRIPE, payload: stripe_account });
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeStripeVerificationLink = (token, stripe_account_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/payment/practice/stripe_verification_link/get/${stripe_account_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      let data = response.data || {};
      let link = data.link;

      if (data.success && link) {
        dispatch({ type: actions.PRACTICE_UPDATE_STRIPE_VERIFICATION_LINK, payload: link });
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeStripeAccountUpdateLink = (token, stripe_account_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/payment/practice/stripe_verification_link/get/${stripe_account_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      let data = response.data || {};
      let link = data.link;

      if (data.success && link) {
        dispatch({ type: actions.PRACTICE_UPDATE_STRIPE_UPDATE_LINK, payload: link });
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const deletePracticeStripeAccount = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/payment/practice/delete/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.delete(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
    }).catch((error) => { console.log(error) });

  }
}

const getFrontDeskAccounts = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/front_desk/users/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data  = response.data || {};
      const users = data.users || [];
      if (data.success) {
        dispatch({ type: actions.PRACTICE_FRONT_DESK_USERS_UPDATE, payload: users });
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const createFrontDeskAccount = (token, accountInfo, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/practice/front_desk`;

    axios.post(requestURL, JSON.stringify(accountInfo), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(ToastActions.displayInfo('Front Desk Account Created'))
        if (callBack) {
          callBack();
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const getFrontDeskUserTasks = (token) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/front_desk/`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data  = response.data || {};
      const tasks = data.tasks || [];
      if (data.success) {

        if (tasks.length > 0) {
          tasks.forEach((task) => {
            const assigner_id  = task.assigner;
            dispatch(getPracticeUserInfo(assigner_id, token));
            dispatch(ConsultationsActions.getConsultationInfo(token, task.consultation_id));
          })
        }

        dispatch({ type: actions.PRACTICE_FRONT_DESK_TASKS_UPDATE, payload: tasks });
      }
    }).catch((error) => { console.log(error) });

  }
}

const changeFrontDeskPassword = (token, info, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/practice/front_desk/change_password`;

    axios.post(requestURL, JSON.stringify(info), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(ToastActions.displayInfo('Front Desk Password Changed'))
        if (callBack) {
          callBack();
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const changeFrontDeskEmail = (token, info, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/practice/front_desk/change_email`;

    axios.post(requestURL, JSON.stringify(info), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(getFrontDeskAccounts(token, info.practice_id));
        dispatch(ToastActions.displayInfo('Front Desk Email Changed'))
        if (callBack) {
          callBack();
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const completeFrontDeskTask = (token, front_desk_task) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/front_desk/update/${front_desk_task._id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    var completedTask = Object.assign({}, front_desk_task);
    completedTask.completed = true;

    axios.put(requestURL, JSON.stringify(completedTask), requestConfig).then((response) => {
      const data  = response.data || {};
      if (data.success) {
        dispatch(getFrontDeskUserTasks(token));
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const updateClientUserProvider = (token, userProviderObject, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/user/provider/${userProviderObject._id}`;

    axios.put(requestURL, JSON.stringify(userProviderObject), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(getPracticeClients(token, userProviderObject.practice_id))
        if (callBack) {
          callBack();
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const addClientUserProvider = (token, userProviderObject, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/user/provider`;

    axios.post(requestURL, JSON.stringify(userProviderObject), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(getPracticeClients(token, userProviderObject.practice_id));
        if (callBack) {
          callBack();
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const getClientProviders = (token, user_id, callBack) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/provider/user_providers/${user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data  = response.data || {};
      const providers = data.providers || [];
      if (data.success && callBack) {
        callBack(providers)
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const addAlert = (token, alert, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/practice/alerts`;

    axios.post(requestURL, JSON.stringify(alert), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(getPracticeAlerts(token, alert.practice_id));
        dispatch(ToastActions.displayInfo('Message Saved!'))
        if (callBack) {
          callBack();
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const editAlert = (token, alert, callBack) => {
  return dispatch => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/practice/alerts/${alert._id}`;

    axios.put(requestURL, JSON.stringify(alert), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {
        dispatch(getPracticeAlerts(token, alert.practice_id));
        dispatch(ToastActions.displayInfo('Message Saved!'))
        if (callBack) {
          callBack();
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeAlerts = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/alerts/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data  = response.data || {};
      const alerts = data.data || [];
      if (data.success) {
        dispatch({ type: actions.PRACTICE_UPDATE_ALERTS, payload: alerts })
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const getProviderAlerts = (token, practice_id, user_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/provider/welcome_message/${practice_id}/${user_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data  = response.data || {};
      const alerts = data.data || [];
      if (data.success) {
        dispatch({ type: actions.PRACTICE_UPDATE_ALERTS, payload: alerts })
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const getPracticeNotificationPreferences = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/notification_preferences/${practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      let data  = response.data || {};
      let preferences = data.preferences || null;

      if (data.success) {
        if (data.none_exists) {
          dispatch(addDefaultNotificationPreferences(token, practice_id));
        } else {
          dispatch({ type: actions.PRACTICE_UPDATE_NOTIFICATION_PREFERENCES, payload: preferences })
        }
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const addDefaultNotificationPreferences = (token, practice_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/default_notification_preferences`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(requestURL, JSON.stringify({ practice_id: practice_id }), requestConfig).then((response) => {
      const data  = response.data || {};

      if (data.success) {
        dispatch(getPracticeNotificationPreferences(token, practice_id));
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const updatePracticeNotificationPreferences = (token, notification_preferences) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/practice/notification_preferences/${notification_preferences.practice_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.put(requestURL, JSON.stringify(notification_preferences), requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getPracticeNotificationPreferences(token, notification_preferences.practice_id))
      }
    }).catch((error) => { console.log(error) });

  }
}

const getClientListForLocation = (location_id, next, prev, page_num, callback) => {
  return (dispatch, getState) => {

    let state         = getState();
    let token         = state && state.user && state.user.auth && state.user.auth.token ? state.user.auth.token : '';
    let page_state    = state && state.practice && state.practice.clientsPageState ? state.practice.clientsPageState : { page_number: 1, location_id: '' };
    let practice_id   = state && state.practice && state.practice.info && state.practice.info._id ? state.practice.info._id : '';
    let updated_state = Object.assign({}, page_state);

    if (next) {
      updated_state.page_number = updated_state.page_number + 1;
    }

    if (prev) {
      updated_state.page_number = updated_state.page_number - 1;
    }

    if (page_num) {
      updated_state.page_number = page_num;
    }

    if (location_id) {
      if (location_id !== updated_state.location_id) {
        updated_state.page_number = 1;
      }
      updated_state.location_id = location_id;
    }

    let page_indexed   = updated_state.page_number - 1;
    let request_url    = `${config.BASE_URL}/api/consolidated/client_list/${practice_id}/${updated_state.location_id}/${15}/${page_indexed}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data  = response.data || {};
      if (data.success) {
        let clients = data.clients || [];
        callback(clients);
      }
    }).catch((error) => { console.log(error) });

    dispatch({ type: actions.PRACTICE_CLIENT_PAGE_STATE_UPDATE, payload: updated_state });

  }
}

const getPreviewClientsForLocation = (token, practice_id, location_id, success_callback, failure_callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/consolidated/client_list/${practice_id}/${location_id}/${5}/${0}/true`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data  = response.data || {};

      if (data.success) {
        let clients = data.clients || [];
        success_callback(location_id, clients);
      } else {
        console.log(data)
        failure_callback();
      }
    }).catch((error) => { console.log(error) });

  }
}

const getClientDetails = (token, user_id, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/consolidated/client_detail/${user_id}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data   = response.data || {};
      let client = data.client;
      let pets   = data.pets || [];

      if (data.success) {
        let user_data = {
          info: client,
          pets: pets,
        }
        callback(user_data);
      } else {

      }
    }).catch((error) => { console.log(error) });

  }
}

const createClientAccount = (token, client_object, success_callback, failure_callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/consolidated/create_client`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify(client_object), request_config).then((response) => {
      let data = response.data || {};

      if (data.success === true) {
        success_callback(client_object.location_id);
        let message = data.message;
        if (message) {
          dispatch(ToastActions.displayInfo(message));
        }
      } else {
        failure_callback();
        let error = data.error;
        if (error) {
          dispatch(ToastActions.displayError(error));
        }
      }
    }).catch((error) => {
      failure_callback();
    });

  }
}

const inviteClient = (token, invite_object, success_callback, failure_callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/consolidated/invite`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify(invite_object), request_config).then((response) => {
      let data = response.data || {};

      if (data.success === true) {
        success_callback();
        let message = data.message;
        if (message) {
          dispatch(ToastActions.displayInfo(message));
        }
      } else {
        failure_callback();
        let error = data.error;
        if (error) {
          dispatch(ToastActions.displayError(error));
        }
      }
    }).catch((error) => {
      failure_callback();
    });

  }
}

const addClientPet = (token, pet_object, success_callback, failure_callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/consolidated/add_patient`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify(pet_object), request_config).then((response) => {
      let data = response.data || {};

      if (data.success === true) {
        success_callback();
        let message = data.message;
        if (message) {
          dispatch(ToastActions.displayInfo(message));
        }
      } else {
        failure_callback();
        let error = data.error;
        if (error) {
          dispatch(ToastActions.displayError(error));
        }
      }
    }).catch((error) => {
      failure_callback();
    });

  }
}

const getProviderListForLocation = (location_id, next, prev, page_num, callback) => {
  return (dispatch, getState) => {

    let state         = getState();
    let token         = state && state.user && state.user.auth && state.user.auth.token ? state.user.auth.token : '';
    let page_state    = state && state.practice && state.practice.providersPageState ? state.practice.providersPageState : { page_number: 1, location_id: '' };
    let practice_id   = state && state.practice && state.practice.info && state.practice.info._id ? state.practice.info._id : '';
    let updated_state = Object.assign({}, page_state);

    if (next) {
      updated_state.page_number = updated_state.page_number + 1;
    }

    if (prev) {
      updated_state.page_number = updated_state.page_number - 1;
    }

    if (page_num) {
      updated_state.page_number = page_num;
    }

    if (location_id) {
      if (location_id !== updated_state.location_id) {
        updated_state.page_number = 1;
      }
      updated_state.location_id = location_id;
    }

    let page_indexed   = updated_state.page_number - 1;
    let request_url    = `${config.BASE_URL}/api/consolidated/provider_list/${practice_id}/${updated_state.location_id}/${15}/${page_indexed}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data  = response.data || {};
      if (data.success) {
        let providers = data.providers || [];
        callback(providers);
      }
    }).catch((error) => { console.log(error) });

    dispatch({ type: actions.PRACTICE_PROVIDER_PAGE_STATE_UPDATE, payload: updated_state });

  }
}

const getPracticeProviders = (token, practice_id, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/consolidated/providers/null/${practice_id}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data      = response.data || {};
      let providers = data.providers || [];

      if (data) {
        let eligible_providers = [];
        providers.forEach((provider, i) => {
          let user = provider && provider.user_details ? provider.user_details : null;
          if (user) {
            let user_object = ArrayUtils.getSingleObject(user);
            eligible_providers.push(user_object);
          }
        });
        callback(eligible_providers)
      }

    }).catch((error) => { console.log(error) })

  }
}

const createPracticeAndSubscription = (token, user_id, practice_data, success_callback, failure_callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/subscription/add`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify(practice_data), request_config).then((response) => {
      let data = response.data || {};

      if (data.success === true) {
        success_callback();
        dispatch(UserActions.getUserRoles(token, user_id, true));
        dispatch(ToastActions.displayInfo('Practice Created Successfully!'));
        history.push(routes.SWITCH_ACCOUNTS);
        let message = data.message;
        if (message) {
          dispatch(ToastActions.displayInfo(message));
        }
      } else {
        failure_callback();
        let error = data.error;
        let message = data.message;
        if (error) {
          dispatch(ToastActions.displayError(error));
        }
        if (message) {
          dispatch(ToastActions.displayError(message));
        }
      }
    }).catch((error) => {
      failure_callback();
    });

  }
}

const upgradePracticeSubscription = (token, practice_id, upgrade_data, success_callback, failure_callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/subscription/update_subscription/${practice_id}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify(upgrade_data), request_config).then((response) => {
      let data = response.data || {};

      if (data.success === true) {
        success_callback();
        dispatch(ToastActions.displayInfo('Practice Upgraded Successfully!'));
        history.push(routes.SWITCH_ACCOUNTS);
        let message = data.message;
        if (message) {
          dispatch(ToastActions.displayInfo(message));
        }
      } else {
        failure_callback();
        let error = data.error;
        if (error) {
          dispatch(ToastActions.displayError(error));
        }
      }
    }).catch((error) => {
      failure_callback();
      dispatch(displayError(error));
      dispatch(ToastActions.displayError(error));
    });

  }
}

const editEnterpriseObject = (token, practice_id, contact_object, success_callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/subscription/edit_enterprise/${practice_id}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    let enterprise_object = {
      practice_id: practice_id,
      enterprise_content: contact_object,
    }

    axios.post(request_url, JSON.stringify(enterprise_object), request_config).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getSelectedPractice());
        success_callback();
        dispatch(ToastActions.displayInfo('Contact Info Saved'))
      } else { dispatch(displayError('', data)) }
    }).catch((error) => {
      console.log(error)
    });

  }
}

const changeSubscriptionCard = (token, practice_id, card_details, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/subscription/add_credit_card/${practice_id}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify(card_details), request_config).then((response) => {
      const data = response.data || {};
      if (data.success === true) {
        dispatch(getSelectedPractice());
        callback(true);
        dispatch(ToastActions.displayInfo('Card Saved'))
      } else {
        callback(false);
        dispatch(displayError(data.message));
      }
    }).catch((error) => {
      console.log(error)
    });

  }
}

const cancelSubscription = (token, practice_id, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/subscription/cancel`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify({ practice_id: practice_id }), request_config).then((response) => {
      const data = response.data || {};

      if (data.success === true) {
        dispatch(getSelectedPractice());
        callback(true);
        dispatch(ToastActions.displayInfo('Subscription Cancelled'))
      } else {
        callback(false);
        dispatch(displayError(data.message));
      }
    }).catch((error) => {
      console.log(error)
    });

  }
}

const getStaffMemberDetails = (token, user_id, practice_id, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/practice/staff_info/${user_id}/${practice_id}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data = response.data || {};
      callback(data);
    }).catch((error) => {
      console.log(error)
      callback({ success: false });
    });

  }
}

const inviteProvider = (token, invite_data, success_callback, failure_callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/invites/invite`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify(invite_data), request_config).then((response) => {
      let data = response.data || {};

      if (data.success === true) {
        success_callback();
        let message = data.message;
        dispatch(ToastActions.displayInfo('An invite has been sent to the provider'));
        if (message) {
          dispatch(ToastActions.displayInfo(message));
        }
      } else {
        failure_callback();
        let error = data.error;
        if (error) {
          dispatch(ToastActions.displayError(error));
        }
      }
    }).catch((error) => {
      failure_callback();
    });

  }
}

const getSentProviderInvites = (token, practice_id, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/invites/get/${practice_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      let data    = response.data || {};
      let invites = data.invites  || [];

      let cleaned_invites = invites.map((inv) => {
        let invite_id = inv._id;
        let user_obj  = ArrayUtils.getSingleObject(inv.user);
        let user_name = StringUtils.displayName(user_obj);
        return {
          invite_id: invite_id,
          invitee_name: user_name,
        }
      }).filter((obj) => { return obj });

      if (data.success && callback) {
        callback(cleaned_invites);
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const cancelSentProviderInvites = (token, invite_id, callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/invites/cancel/${invite_id}`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify({}), request_config).then((response) => {
      let data = response.data || {};

      if (data.success === true) {
        callback();
        let message = data.message;
        dispatch(ToastActions.displayInfo('Invite Cancelled'))
        if (message) {
          dispatch(ToastActions.displayInfo(message));
        }
      } else {
        callback();
        let error = data.error;
        if (error) {
          dispatch(ToastActions.displayError(error));
        }
      }
    }).catch((error) => {
      callback();
    });

  }
}

const createProviderAccount = (token, create_account_data, success_callback, failure_callback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/invites/create_user`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(request_url, JSON.stringify(create_account_data), request_config).then((response) => {
      let data = response.data || {};

      if (data.success === true) {
        success_callback();
        let message = data.message;
        dispatch(ToastActions.displayInfo('An account for the provider has been created.'))
        if (message) {
          dispatch(ToastActions.displayInfo(message));
        }
      } else {
        failure_callback();
        let error = data.error;
        if (error) {
          dispatch(ToastActions.displayError(error));
        }
      }
    }).catch((error) => {
      failure_callback();
    });

  }
}

const getSubscriptionTypes = (token, dataCallback) => {
  return dispatch => {

    let request_url    = `${config.BASE_URL}/api/subscription/get_subscription_types`;
    let request_config = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(request_url, request_config).then((response) => {
      let data               = response.data || {};
      let subscription_types = data.subscription_types || null;
      if (data.success) {
        dataCallback(subscription_types);
      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const openUnassignedClient = (client) => {
  return dispatch => {
    dispatch({ type: actions.PRACTICE_SELECTED_UNASSIGNED_CLIENT, payload: client });
    history.push(routes.PRACTICE_ASSIGN_CLIENT);
  }
}

const openPracticeStaffMemberDetails = (token, user_id, roles) => {
  return dispatch => {
    dispatch({
      type: actions.PRACTICE_STAFF_MEMBER_SELECTED_UPDATE,
      payload: user_id
    })
    dispatch({
      type: actions.PRACTICE_STAFF_MEMBER_SELECTED_ROLES_UPDATE,
      payload: roles
    })
    dispatch(getPracticeUserInfo(user_id, token))
    history.push(routes.PRACTICE_STAFF_MEMBER_DETAILS);
  }
}

const updateSelectedStaffMemberRoles = (roles) => {
  return dispatch => {
    dispatch({
      type: actions.PRACTICE_STAFF_MEMBER_SELECTED_ROLES_UPDATE,
      payload: roles
    })
  }
}

const openPracticeAddEditBank = () => {
  return dispatch => {
    history.push(routes.PRACTICE_BANK_EDIT);
  }
}

const openPracticeNotificationPreferences = () => {
  return dispatch => {
    history.push(routes.PRACTICE_NOTIFICATION_PREFERENCES);
  }
}

const openSubscriptionDetails = () => {
  return dispatch => {
    history.push(routes.SUBSCRIPTION_DETAILS);
  }
}

const openPracticeFrontDeskEdit = (location) => {
  return dispatch => {
    dispatch({
      type: actions.PRACTICE_FRONT_DESK_SELECT,
      payload: location
    })
    history.push(routes.PRACTICE_FRONT_DESK_EDIT);
  }
}

const openPracticeLocationDetails = (token, location) => {
  return dispatch => {
    dispatch({
      type: actions.PRACTICE_LOCATIONS_DETAILS_SELECT,
      payload: location
    });
    history.push(routes.PRACTICE_LOCATION_DETAILS);
  }
}

const openReassignConsultation = () => {
  return dispatch => {
    history.push(routes.CONSULTATION_REASSIGN);
  }
}

const openEditAdmins = () => {
  return dispatch => {
    history.push(routes.PRACTICE_ADMINS_EDIT);
  }
}

const openEditPractice = () => {
  return dispatch => {
    history.push(routes.PRACTICE_INFO_EDIT);
  }
}

export default {
  acceptPracticeJoinRequest,
  addAlert,
  addClientPet,
  addPracticeBank,
  addPracticeLocation,
  cancelSentProviderInvites,
  cancelSubscription,
  createClientAccount,
  createNewPractice,
  createFrontDeskAccount,
  createPracticeAndSubscription,
  createPracticeStripeAccount,
  createProviderAccount,
  changeFrontDeskEmail,
  changeFrontDeskPassword,
  changeSubscriptionCard,
  editAlert,
  editEnterpriseObject,
  editPracticeLocation,
  editPracticeInfo,
  declinePracticeJoinRequest,
  deletePracticeJoinRequest,
  deletePracticeStripeAccount,
  displayError,
  displayInfo,
  getPreviewClientsForLocation,
  getClientDetails,
  getPracticeStripeAccount,
  getPracticeAlerts,
  getPracticeJoinRequests,
  getPracticeLocations,
  getProration,
  inviteClient,
  inviteProvider,
  openEditPractice,
  populateSelectedPracticeInfo,
  selectPracticeLocationToEdit,
  getClientProviders,
  getClientListForLocation,
  getFrontDeskAccounts,
  getFrontDeskUserTasks,
  getPracticeActiveConsultations,
  getPracticeProcessingConsultations,
  getPracticeClientUserInfo,
  getPracticeResolvedConsultations,
  getPracticeBank,
  getPracticeStaff,
  getPracticeClients,
  getProviderAlerts,
  getProviderListForLocation,
  getPracticeNotificationPreferences,
  getPracticeProviders,
  getStaffMemberDetails,
  getSelectedPractice,
  getSelectedPracticeSubscription,
  getSentProviderInvites,
  getSubscriptionTypes,
  openPracticeStaffMemberDetails,
  openEditAdmins,
  openUnassignedClient,
  openPracticeFrontDeskEdit,
  updatePracticeUserRole,
  updatePracticeNotificationPreferences,
  openReassignConsultation,
  getPracticePatientInfo,
  openPracticeLocationDetails,
  openPracticeAddEditBank,
  openPracticeNotificationPreferences,
  openSubscriptionDetails,
  updateClientUserProvider,
  addClientUserProvider,
  completeFrontDeskTask,
  upgradePracticeSubscription,
}
